define([
        'jQuery'
    ],
    function($) {

        var DirectOfferValidityCheck = {
            init: function() {
                // Delay to avoid JS request errors
                var delay = 100;
                var offerList = $('#offerlist');
                var checkOfferAmount = offerList.attr('data-offer-check-amount');

                if (checkOfferAmount) {
                    $('[data-fcse-role="check-offer-button"]:lt('+checkOfferAmount+')', offerList).each(function() {
                        var targetElement = $(this);
                        var checkData = targetElement.attr('data-offer-valitity-check');

                        if (!checkData) {
                            setTimeout(function() {
                                targetElement.click()
                            }, delay);
                        }
                    });
                }
            }
        };

        return DirectOfferValidityCheck;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/offervaliditycheck/directOfferValidityCheck.js